import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// PWA: registrér service worker (standard CRA-mønster). Kun aktiv i
// production build. Ved ny version: giv brugeren en synlig prompt i stedet
// for en tavs opdatering — genbruger det eksisterende nyVersionBanner
// (se hooks/useDashboard.js) via et custom window-event, så der ikke
// opstår to konkurrerende "ny version"-UI'er.
serviceWorkerRegistration.register({
  onUpdate: () => {
    window.dispatchEvent(new CustomEvent('sv:sw-update-available'));
  },
});
